<div class="sx-metering-scope__component" *ngIf="!!meteringPointsCount && meteringPointsCount >= 1">
  <header class="sx-metering-scope__header">

    <div class="sx-metering-scope__hotcoldwrapper">
      <div class="sx-metering-scope__section sx-metering-scope__section--hot" [hidden]="meteringType === meteringTypeEnum.ColdLogical">
        <svg class="sx-metering-scope__service-icon">
          <use xlink:href="#sx-varme" href="#sx-varme" />
        </svg>
        <span class="sx-metering-scope__service-text">{{ 'metering.filter.title_hot' | translate }}</span>
      </div>

      <div class="sx-metering-scope__section sx-metering-scope__section--cold" [hidden]="meteringType === meteringTypeEnum.HotLogical">
        <svg class="sx-metering-scope__service-icon">
          <use xlink:href="#sx-kyla" href="#sx-kyla" />
        </svg>
        <span class="sx-metering-scope__service-text">{{ 'metering.filter.title_cold' | translate }}</span>
      </div>
    </div>

    <div class="sx-metering-scope__contentwrapper">
      <div class="sx-metering-scope__section sx-metering-scope__section--grow sx-metering-scope__titlewrapper">
        <h2 class="sx-metering-scope__heading"
          *ngIf="!filterSettings || filterSettings.filterType == filterSettingsTypeEnum.Unfiltered">
          {{ 'metering.filter.all' | translate }}
        </h2>

        <h2 class="sx-metering-scope__heading"
          *ngIf="filterSettings && filterSettings.filterType != filterSettingsTypeEnum.Unfiltered">
          {{filterSettings.name}}
        </h2>

        <div [ngClass]="{'sx-metering-scope__subtitle': subfilterEnabled}"
          *ngIf="!filterSettings || filterSettings.filterType == filterSettingsTypeEnum.Unfiltered"
          (click)="toggleSubFilter()">{{meteringPointsCountLabel}} {{ 'metering.filter.subtitle' | translate }}
          <div class="sx-metering-scope__subtitle-select-wrapper" *ngIf="subfilterEnabled">
            <div *ngIf="subfilterEnabled"
              [className]="subfilterOpenState ? 'sx-metering-scope__subtitle-unselect' : 'sx-metering-scope__subtitle-select'">
            </div>
          </div>
        </div>
        <div [ngClass]="{'sx-metering-scope__subtitle': subfilterEnabled}"
          *ngIf="filterSettings && filterSettings.filterType !== filterSettingsTypeEnum.Unfiltered && meteringPointsCountLabel.trim().length > 0"
          (click)="toggleSubFilter()">{{meteringPointsCountLabel}} {{ 'metering.filter.subtitle' | translate }}
          <div class="sx-metering-scope__subtitle-select-wrapper" *ngIf="subfilterEnabled">
            <div
              [className]="subfilterOpenState ? 'sx-metering-scope__subtitle-unselect' : 'sx-metering-scope__subtitle-select'">
            </div>
          </div>
        </div>
      </div>

      <div class="sx-metering-scope__functionwrapper">
        <div *ngIf="meteringPointsCount > 1" class="sx-metering-scope__section sx-metering-scope__section--padless">
          <button mat-button class="sx-metering-scope__button" (click)="configureFilter()">
            <span class="sx-metering-scope__buttontext-long">{{'metering.filter.edit_logical' | translate}}</span>
            <span class="sx-metering-scope__buttontext-short" aria-hidden="true">{{'metering.filter.edit_short_logical' | translate}}</span>
            <svg class="sx-metering-scope__mp-icon">
              <use xlink:href="#sx-andra-urval-for-matpunkter" href="#sx-andra-urval-for-matpunkter"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </header>
    <mat-expansion-panel #subfilterPanel
        (opened)="subfilterOpenState = true"
        (closed)="subfilterOpenState = true"
        *ngIf="subfilterEnabled"
        class="sx-metering-scope__subfilter">
      <div *ngIf="filterSettings && filterSettings.subfilter">
        <div *ngIf="filterSettings.subfilter.includedMeteringPoints" class="sx-metering-scope__subfilter__grid">
          <div *ngFor="let mp of filterSettings.subfilter.includedMeteringPoints"
            class="sx-metering-scope__subfilter__point big">
            <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
              <span title="{{mp.name}} ({{mp.id}})">{{mp.name}}</span>
              <span class="sxh-text-mp-id" title="{{mp.name}} ({{mp.id}})">({{mp.id}})</span>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="sx-metering-scope__subfilter__footer">
          <div>
            <button mat-button class="sx-button sx-metering-scope__subfilter__button"
              (click)="toggleAllInSubfilter(true)">
              {{ 'metering.filter.subfilter_select_all' | translate }}
            </button>
            <button mat-button class="sx-button sx-metering-scope__subfilter__button"
              (click)="toggleAllInSubfilter(false)">
              {{ 'metering.filter.subfilter_unselect_all' | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
 </div>
